<template>
  <v-container grid-list-md class="pa-0 ma-0">
    <v-layout row wrap>
      <v-flex xs6>
        <router-link :to="{ path: '/Facdash/' }" style="text-decoration: none; color: black;">
          <v-btn small flat class="px-0 pb-0 pt-2 ml-0"><v-icon>keyboard_backspace</v-icon></v-btn>
        </router-link>
      </v-flex>
      <v-flex xs6 class="text-xs-right">
        <v-btn class="accent" @click="downoadAsPdf">Download As Pdf</v-btn>
      </v-flex>
      <v-flex xs12 id="pdf_report">
        <v-card flat>
          <v-card-title class="pa-0 title">
            <v-flex xs12>
              <v-layout row wrap>
                <v-flex xs6>
                  <div class="text-xs-left pt-2">{{lReport.comm_name}} - FM Weekly Report ({{lReport.rep_date}} - {{this.repo_to_date}})</div>
                </v-flex>
                <v-flex xs6>
                  <div class="text-xs-right">
                    <img height="100" width="250" src="../../static/img/logo//integra_logo.png"/>
                  </div>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12>
              <v-divider style="border-top:3px solid black"></v-divider>
            </v-flex>
            </v-card-title>

            <!-- Attendance Summary -->
            <v-flex xs12 pa-0>
              <div class="text-xs-center title py-1 warning--text">Attendance Summary</div>
            </v-flex>
            <v-flex pa-0 style="border: 1px solid black;">
              <v-card-text pa-0>
                <v-data-table
                  :headers="$vuetify.breakpoint.smAndUp ? repHeadSm : repHead"
                  :items="attReport"
                  hide-actions>
                  <template slot="items" slot-scope="props">
                    <tr>
                      <td>{{ props.item.staff_role }}</td>
                      <td>{{ props.item.tot_present }}</td>
                      <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.tot_wo }}</td>
                      <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.tot_holiday }}</td>
                      <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.tot_ot }}</td>
                      <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.tot_leave }}</td>
                      <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.tot_absent }}</td>
                      <td class="red--text pa-0">{{ props.item.tot_pend }}</td>
                    </tr>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-flex>

          <!-- Power Management -->
          <v-flex xs12 class="pa-0">
            <div class="text-xs-center title py-2 warning--text">Power Management</div>
          </v-flex>
          <v-flex xs12 style="border: 1px solid black;">
            <v-layout row wrap>
              <v-flex xs12 sm2 class="pa-0">
                <div class="text-xs-center py-2" style="font-size: 12px; background-color: #215868; color: #fff;">CONSUMPTION</div>
                <v-flex xs12>
                  <v-layout row wrap>
                    <v-flex xs4 style="font-size: 12px; height: 78px;" class="text-xs-center primary white--text py-4">
                      <span>EB</span>
                    </v-flex>
                    <v-flex xs8 class="text-xs-center py-4">
                      <span style="font-size: 12px;">{{lReport.eb_unit ? lReport.eb_unit.toFixed(0) : '0'}} units</span>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12>
                  <v-layout row wrap>
                    <v-flex xs4 style="font-size: 12px; height: 78px;" class="text-xs-center mt-0 primary white--text py-4">
                      <span>DG</span>
                    </v-flex>
                    <v-flex xs8 class="text-xs-center py-4">
                      <span style="font-size: 12px;">{{lReport.dg_unit ? lReport.dg_unit.toFixed(0) : '0'}} units</span>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-flex>
              <v-flex xs12 sm10 class="pa-0">
                <div class="text-xs-center py-2" style="font-size: 12px; background-color: #215868; color: #fff;">DISTRIBUTION (UNITS)</div>
                <v-flex xs12>
                  <v-layout row wrap>
                    <v-flex xs6 class="pa-0">
                      <div id="div_powercons" class="text-xs-center">
                        <canvas id="chart_powercons"></canvas>
                      </div>
                    </v-flex>
                    <v-flex xs6 class="pl-4 py-0">
                      <div id="div_powergenset" class="text-xs-center">
                        <canvas id="chart_powergenset"></canvas>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12>
            <v-layout row wrap>
              <v-flex xs12 class="mt-2">
                <v-layout row wrap>
                  <v-flex xs8 class="pa-0" style="border: 1px solid black;">
                    <v-flex xs12 class="text-xs-center py-2" style="font-size: 12px; background-color: #215868; color: #fff;">
                      <div>DG SUMMARY</div>
                    </v-flex>
                    <v-flex xs12 class="pa-0">
                      <v-flex xs12>
                        <v-layout row wrap>
                          <v-flex class="primary white--text text-xs-center py-2" v-for="(genset, i) in gensetHead" :key="i">
                            <span style="font-size: 12px;">{{genset.text}}</span>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-data-table
                      hide-headers
                      disable-initial-sort
                      :items="gensetList"
                      hide-actions>
                      <template slot="items" slot-scope="props">
                        <tr class="text-xs-center">
                          <td style="font-size: 12px; width: 139px;" class="pa-0">{{ props.item.genset_nm ? props.item.genset_nm : '-' }}</td>
                          <td style="font-size: 12px; width: 139px;" class="pa-0">{{ props.item.units_cons ? props.item.units_cons : '-' }}</td>
                          <td style="font-size: 12px; width: 139px;" class="pa-0">{{ props.item.level ? props.item.level + '%' : '-' }}</td>
                          <td style="font-size: 12px; width: 139px;" class="pa-0">{{ props.item.run_hrs ? props.item.run_hrs : '-' }}</td>
                        </tr>
                      </template>
                    </v-data-table>
                  </v-flex>
                </v-flex>
                <v-flex xs4 class="pa-0" style="border-top: 1px solid black;border-bottom: 1px solid black;border-right: 1px solid black;">
                  <v-flex xs12 class="text-xs-center py-2" style="font-size: 12px; background-color: #215868; color: #fff;">
                    <div>DIESEL PURCHASE &amp; STOCK</div>
                  </v-flex>
                  <v-flex xs12 class="pa-0">
                    <v-flex xs12>
                      <v-layout row wrap>
                        <v-flex xs6 class="primary white--text text-xs-center py-2" v-for="(diesel, i) in dieselHead" :key="i">
                          <span style="font-size: 12px">{{diesel.text}}</span>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-data-table
                    hide-headers
                    disable-initial-sort
                    :items="dieselList"
                    hide-actions>
                    <template slot="items" slot-scope="props">
                      <tr class="text-xs-center">
                        <td style="font-size: 12px; width: 173px;" class="pa-0">{{ props.item.diesel_nm ? props.item.diesel_nm : '-' }}</td>
                        <td style="font-size: 12px; width: 173px;" class="pa-0">{{ props.item.val ? props.item.val : '-' }}</td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-flex>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
      <div class="caption pl-1" v-if="lReport.remark_power">
        <span style="font-size: 12px; font-weight: bold;">Remark:</span> {{ lReport.remark_power }}
      </div>
      <v-flex xs12 class="pa-0" :id="dieselList.length < 4 ? 'pageBreak' : ''">
        <div class="text-xs-center title py-2 warning--text">Water Management</div>
      </v-flex>
      <v-flex xs12 style="border: 1px solid black;" class="pa-0">
        <v-layout row wrap>
          <!-- <v-flex xs12 sm5 class="px-0">
            <v-flex xs12 class="text-xs-center py-2" style="font-size: 12px; background-color: #215868; color: #fff;">
              <span>WATER LEVEL (%)</span>
            </v-flex>
            <v-flex xs10>
              <div id="div_waterlevel" class="text-xs-center">
                <canvas id="chart_waterlevel"></canvas>
              </div>
            </v-flex>
          </v-flex> -->
          <v-flex xs12 sm5 class="px-0">
            <v-flex xs12 class="text-xs-center py-2" style="font-size: 12px; background-color: #215868; color: #fff;">
              <span>CONSUMPTION-Domestic (KL)</span>
            </v-flex>
            <v-flex xs10 class="text-xs-center">
              <div id="div_watercons">
                <canvas id="chart_watercons"></canvas>
              </div>
              <div class="subheading pl-1">
                <span style="font-weight: bold;">Total water consumed: {{ lReport.tot_water_cons > 0 ? lReport.tot_water_cons.toFixed(0) + ' KL' : '0 KL' }}</span>
              </div>
            </v-flex>
          </v-flex>
          <v-flex xs12 sm5 class="px-0">
            <v-flex xs12 class="text-xs-center py-2" style="font-size: 12px; background-color: #215868; color: #fff;">
              <span>CONSUMPTION-Treated (KL)</span>
            </v-flex>
            <v-flex xs10 class="text-xs-center">
              <div id="div_watercons">
                <canvas id="chart_watercons"></canvas>
              </div>
              <div class="subheading pl-1">
                <span style="font-weight: bold;">Total water consumed: {{ lReport.tot_water_cons > 0 ? lReport.tot_water_cons.toFixed(0) + ' KL' : '0 KL' }}</span>
              </div>
            </v-flex>
          </v-flex>
          <v-flex xs12 sm2 class="px-0">
            <v-flex xs12 class="text-xs-center py-2" style="font-size: 12px; background-color: #215868; color: #fff;">
              <span>SOURCES (KL)</span>
            </v-flex>
            <v-flex xs12 v-for="(wat, i) in domWatList" :key="i" class="py-2 pl-2">
              <v-layout row wrap>
                <v-flex xs9 class="text-xs-left">
                  <div style="font-size: 12px;">{{wat.water_type}}</div>
                </v-flex>
                <v-flex xs3 class="text-xs-left title">
                  <div style="font-size: 12px;">{{wat.water_receipt ? wat.water_receipt.toFixed(0) : 0}}</div>
                </v-flex>
              </v-layout>
            </v-flex>
            <div class="subheading pl-1">
              <span style="font-weight: bold;">Total Water Source: {{ lReport.tot_water_source > 0 ? lReport.tot_water_source.toFixed(0) + ' KL' : '0 KL' }}</span>
            </div>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 class="text-xs-center mt-2 py-2" style="font-size: 12px; background-color: #215868; color: #fff;">
        <div>WATER QUALITY &amp; CONTROL</div>
      </v-flex>
      <v-flex xs12 class="pa-0" style="border: 1px solid black;">
        <v-flex xs12>
          <v-layout row wrap>
            <v-flex class="primary white--text text-xs-center py-2" v-for="(param, i) in paramHead" :key="i">
              <span style="font-size: 12px">{{param.text}}</span>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-data-table
        hide-headers
        :items="paramList"
        hide-actions
        disable-initial-sort
        >
        <template slot="items" slot-scope="props">
          <tr class="text-xs-center">
            <td style="font-size: 12px; width: 174px;" class="pa-0">{{ props.item.water_qual }}</td>
            <td style="font-size: 12px; width: 174px;" :class="'pa-0 ' + (watQualVal.val && (watQualVal.val < watQualVal.stdValMin || watQualVal.val > watQualVal.stdValMax) ? 'red white--text' : (watQualVal.val ? 'green lighten-3' : ''))" v-for="(watQualVal, i) in props.item.waterQualTypeValue" :key="i">
              {{ watQualVal.val ? watQualVal.val : '-' }}
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-flex>
    <div class="caption pl-1" v-if="lReport.remark_water">
      <span style="font-size: 12px; font-weight: bold;">Remark:</span> {{ lReport.remark_water }}
    </div>
    <v-flex xs12 class="pa-0">
      <div class="text-xs-center title py-2 warning--text">Waste Management</div>
    </v-flex>
    <v-flex xs12 style="border: 1px solid black;" class="pa-0">
      <v-layout row wrap>
        <v-flex xs12>
          <div id="div_waste" class="text-xs-center">
            <canvas id="chart_waste"></canvas>
          </div>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex xs12 class="pa-0" id="pageBreak">
      <div class="text-xs-center title py-2 warning--text">Hygiene Management / Sanity Checks</div>
          <v-flex xs12 style="border: 1px solid black;">
          <v-layout row wrap>
            <v-flex xs12 class="text-xs-center py-2" style="font-size: 12px; background-color: #215868; color: #fff;">
              <span>SANITY CHECKS</span>
            </v-flex>
          </v-layout>
          </v-flex>
        <v-card-text>
          <v-flex xs12 v-for="(item, n) in lSan" :key="n" :class="n > 0 ? 'mt-2' : ''">
            <div class="pa-2 primary white--text">{{item}}</div>
            <v-data-table
            :headers="sanHeads"
            :items="sanList.filter(rec => handy.formatDate(rec.c_date) === item)"
            hide-actions
            disable-initial-sort
            class="elevation-1"
            >
            <template slot="items" slot-scope="props">
              <tr>
                <td class="text-xs-right" style="width: 50px;">
                  <v-checkbox v-model="props.item.check_value" class="pt-2" hide-details readonly></v-checkbox>
                </td>
                <td>{{ props.item.check_cat }}</td>
                <td>{{ props.item.check_desc }}</td>
                <td style="width: 340px;">{{ props.item.remark ? props.item.remark : '-' }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>
      </v-card-text>
    </v-flex>
  <div class="caption pl-1" v-if="lReport.remark_sanity_checks">
    <span style="font-size: 12px; font-weight: bold;">Remark:</span> {{ lReport.remark_sanity_checks }}
  </div>
  <v-flex xs12 class="pa-0">
    <div class="text-xs-center title py-2 warning--text">Safety &amp; Security</div>
  </v-flex>
  <v-flex xs12 style="border: 1px solid black;">
    <v-layout row wrap>
      <v-flex xs12 class="text-xs-center py-2" style="font-size: 12px; background-color: #215868; color: #fff;">
        <span>INCIDENTS</span>
      </v-flex>
      <v-flex xs12 class="pa-0" style="border-top: 1px solid black;">
        <v-flex xs12 v-for="(incident, n) in incidentTypes" :key="n" class="pa-0">
          <div class="text-xs-left pa-2 primary white--text" style="font-size: 12px;">{{incident}}</div>
          <v-flex xs12 class="pa-0">
            <v-data-table
            hide-headers
            :items="incidentList.filter(rec => rec.incident_type === incident)"
            hide-actions
            disable-initial-sort>
            <template slot="items" slot-scope="props">
              <tr>
                <td style="font-size: 12px; width:315px;">{{ props.item.incident_class }}</td>
                <td>{{ props.item.incident_on ? (handy.formatDate(props.item.incident_on) + ' ' + handy.getTime12Hrs(props.item.incident_on) + (props.item.incident_end ? ' to ' + handy.formatDate(props.item.incident_end) + ' ' + handy.getTime12Hrs(props.item.incident_end) : '') + ' - ' + props.item.incident_desc) : '' }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>
      </v-flex>
    </v-flex>
  </v-layout>
</v-flex>
<v-flex xs12 class="pa-0">
  <div class="text-xs-center title py-2 warning--text">52 Week PPM Planner</div>
</v-flex>
<v-flex xs12 style="border: 1px solid black;">
  <v-layout row wrap>
    <v-flex xs12 class="text-xs-center py-2" style="font-size: 12px; background-color: #215868; color: #fff;">
      <span>PPM PLANNER</span>
    </v-flex>
    <v-flex xs12 class="pa-0" style="border-top: 1px solid black;">
      <v-flex xs12 class="pa-0" v-if="lPpmHeader.length > 0">
        <v-flex xs12>
          <v-layout row wrap>
            <v-flex class="primary white--text text-xs-left pa-2" v-for="(ppm, i) in ppmHeader" :key="i">
              <span style="font-size: 12px">{{ppm.text}}</span>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-data-table
        hide-headers
        :items="lPpmHeader"
        hide-actions
        disable-initial-sort>
        <template slot="items" slot-scope="props">
          <tr class="text-xs-left">
            <td style="font-size: 12px; width: 162px;" class="pa-2">{{ props.item.asset_tag ? props.item.asset_tag : '-' }}</td>
            <td style="font-size: 12px; width: 158px;" class="pa-2">{{ props.item.asset_cat ? props.item.asset_cat : '-' }}</td>
            <td style="font-size: 12px; width: 191px;" class="pa-2">{{ props.item.noneq_name ? props.item.noneq_name : '-' }}</td>
            <td style="font-size: 12px; width: 164px;" class="pa-2">{{ props.item.freq }}</td>
            <td style="font-size: 12px; width: 156px;" class="pa-2">{{ props.item.asset_location ? props.item.asset_location : '-' }}</td>
            <td style="font-size: 12px;" class="pa-2">{{ props.item.ppm_status }}</td>
          </tr>
        </template>
      </v-data-table>
    </v-flex>
    <v-flex xs12 v-else class="pl-4">
      NIL
    </v-flex>
  </v-flex>
</v-layout>
</v-flex>
<!-- <v-flex xs12 class="pa-0" id="pageBreak">
  <div class="text-xs-center title py-2 warning--text">Complaints &amp; Task Management</div>
</v-flex>
<v-flex xs12 style="border: 1px solid black;">
  <v-layout row wrap>
    <v-flex xs12 sm8 class="pa-0" style="border-right: 1px solid black;">
      <v-flex xs12 class="text-xs-center py-2" style="font-size: 12px; background-color: #215868; color: #fff;">
        <span>COMPLAINTS</span>
      </v-flex>
      <v-flex xs12>
        <v-layout row wrap>
          <v-flex class="primary white--text text-xs-left pa-2" v-for="(comp, i) in compHead" :key="i">
            <span style="font-size: 12px">{{comp.text}}</span>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-data-table
      hide-headers
      :items="compList"
      hide-actions
      disable-initial-sort
      >
      <template slot="items" slot-scope="props">
        <tr class="text-xs-left">
          <td style="font-size: 12px; width: 139px;" class="pa-2">{{ props.item.comp_cat }}</td>
          <td style="font-size: 12px; width: 139px;" class="pa-2">{{ props.item.prev_pend }}</td>
          <td style="font-size: 12px; width: 139px;" class="pa-2">{{ props.item.new_today }}</td>
          <td style="font-size: 12px; width: 139px;" class="pa-2">{{ props.item.reop_today }}</td>
          <td style="font-size: 12px; width: 139px;" class="pa-2">{{ props.item.closed_today }}</td>
          <td style="font-size: 12px; width: 139px;" class="pa-2">{{ props.item.closing_bal }}</td>
        </tr>
      </template>
    </v-data-table>
  </v-flex>
  <v-flex xs12 sm4 class="pa-0">
    <v-flex xs12 class="text-xs-center py-2" style="font-size: 12px; background-color: #215868; color: #fff;">
      <span>TASK</span>
    </v-flex>
    <div id="div_task" class="pt-3 pr-1 text-xs-center">
      <canvas id="chart_task"></canvas>
    </div>
  </v-flex>
</v-layout>
</v-flex>
<v-flex xs12 class="pa-0" v-if="lMet.length > 0">
  <div class="text-xs-center title py-2 warning--text">Custom Metrics</div>
</v-flex>
<v-flex xs12 v-if="lMet.length > 0">
  <v-layout row wrap>
    <v-flex xs3 v-for="(metric, n) in lMet" :key="n" style="border: 1px solid black;" class="pa-0">
      <div class="pa-2 text-xs-center" style="font-size: 12px; background-color: #215868; color: #fff;" v-if="metric">
        {{ metric.metric_cat.toUpperCase() }}
      </div>
      <v-flex xs12 class="pa-0">
        <v-flex xs12>
          <v-layout row wrap>
            <v-flex class="primary white--text text-xs-center py-2" v-for="(met, i) in metHead" :key="i">
              <span style="font-size: 12px">{{met.text}}</span>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-data-table
        hide-headers
        :items="metricList.filter(rec => rec.metric_cat === metric.metric_cat)"
        disable-initial-sort
        hide-actions>
        <template slot="items" slot-scope="props">
          <tr class="text-xs-center">
            <td style="font-size: 12px; width: 130px;" class="px-1">{{ props.item.metric_nm ? props.item.metric_nm : '-' }}</td>
            <td style="font-size: 12px; width: 130px;" class="px-1">{{ props.item.metric_val ? props.item.metric_val : 0 }}</td>
          </tr>
        </template>
      </v-data-table>
    </v-flex>
  </v-flex>
</v-layout>
</v-flex> -->
<div class="caption pl-1" v-if="lReport.remark_custom_metrics">
  <span style="font-size: 12px; font-weight: bold;">Remark:</span> {{ lReport.remark_custom_metrics }}
</div>
<div class="caption pa-1" v-if="lReport.major_observ">
  <div class="text-xs-center title py-2 warning--text">Major Observation</div>
  <div class="pa-1" v-html="handy.getEditorStyle() + lReport.major_observ" style="font-size: 12px; border: 1px solid black;"></div>
</div>
<v-flex xs12 class="pa-0" id="pageBreak" v-if="lDailyUpdateAttach.files && lDailyUpdateAttach.files.length > 0">
  <div style="color: #ff7f2a; font-size: 20px; font-weight: bold; text-align: center; padding: 7px 0px;">Photos</div>
</v-flex>
<v-flex xs12>
  <v-container grid-list-md class="pa-0">
    <v-layout row wrap v-if="lDailyUpdateAttach.files && lDailyUpdateAttach.files.length > 0">
      <v-flex xs12 sm4 v-for="(file, index) in lDailyUpdateAttach.files" :key="index" class="pa-1 text-xs-center">
        <v-card-media
        class="black--text caption"
        height="210px"
        :src="file.file_url"
        >
        <div class="white--text" style="background-color:rgba(125, 125, 125, 0.5);">{{handy.formatDBDateTime(file.attach_timestamp)}}<br />by {{file.user_name}}</div>
        <div style="position:absolute; bottom:0px; width:100%; background-color:rgba(0, 0, 255, 0.5);" class="text-xs-center white--text" v-if="file.notes">
          {{ file.notes }}
        </div>
      </v-card-media>
    </v-flex>
  </v-layout>
</v-container>
</v-flex>
</v-card-text>
</v-card>
</v-flex>
</v-layout>
<!-- snack bar for reporting -->
<v-snackbar :color="sbarCol" v-model="sbar" :timeout="2000" multi-line>
  <span class="mx-auto">{{ sbarMsg }}</span>
</v-snackbar>
</v-container>
</template>

<script>
import config from '@/config/app-cfg'
import handy from '@/utils/handy'
var Chart = require('chart.js')
import 'chartjs-plugin-datalabels'
var html2pdf = require('html2pdf.js')

var COLORS = ['227,108,9', '49,133,155', '95,73,122', '118,146,60', '149,55,52', '54,96,146', '23,54,93', '73,68,41']

export default {
  props: ['action'],
  data () {
    return {
      // common
      sbar: false,
      sbarCol: 'error',
      sbarMsg: '',
      config: config,
      handy: handy,
      lReport: {},
      // Attendance
      attHead: [],
      attList: [],
      // complaint
      compHead: [
        { text: 'Category', value: 'comp_cat', class: 'font px-2 primary white--text text-xs-center', sortable: false },
        { text: 'Previous Pending', value: 'prev_pend', class: 'font px-2 primary white--text text-xs-center', sortable: false },
        { text: 'Today’s New', value: 'new_today', class: 'font px-2 primary white--text text-xs-center', sortable: false },
        { text: 'Reopened Today', value: 'reop_today', class: 'font px-2 primary white--text text-xs-center', sortable: false },
        { text: 'Closed Today', value: 'closed_today', class: 'font px-2 primary white--text text-xs-center', sortable: false },
        { text: 'Closing Balance', value: 'closing_bal', class: 'font px-2 primary white--text text-xs-center', sortable: false }
      ],
      compList: [],
      // water quality
      paramHead: [],
      paramList: [],
      // water sources
      domWatList: [],
      // custom Metrics
      lMet: {},
      metHead: [
        { text: 'Metric Name', value: 'metric_nm', width: '300px', class: 'font primary white--text', sortable: false },
        { text: 'Value', value: 'metric_val', width: '100px', class: 'font primary white--text', sortable: false }
      ],
      metricList: [],
      // DG
      lGenset: {},
      gensetHead: [
        { text: 'Genset', value: 'genset_nm', class: 'font primary white--text pl-2 pr-0', sortable: false },
        { text: 'Units(KWH)', value: 'units_cons', class: 'font primary white--text px-0', sortable: false },
        { text: 'Diesel Level (%)', value: 'level', class: 'font primary white--text px-0', sortable: false },
        { text: 'Running Hours', value: 'run_hrs', class: 'font primary white--text px-0', sortable: false }
      ],
      gensetList: [],
      dieselHead: [
        { text: 'Metric', value: 'diesel_nm', class: 'font primary white--text', sortable: false },
        { text: 'Quantity (ltr)', value: 'val', class: 'font primary white--text', sortable: false }
      ],
      dieselList: [],
      lgen: {},
      // Hygiene
      hygList: [],
      sanList: [],
      lSan: {},
      hygCats: {},
      sanHeads: [
        { text: '', value: 'check_value' },
        { text: 'Category', value: 'check_cat' },
        { text: 'Description', value: 'check_desc' },
        { text: 'Remark', value: 'remark' }
      ],
      // incident
      incidentList: [],
      incidentTypes: {},
      // comm values
      nodata: false,
      // for chart
      tmpChart: [],
      // ppm planner
      ppmHeader: [
        { text: 'Asset Tag', values: 'asset_tag', class: 'primary white--text py-0' },
        { text: 'Category', values: 'asset_cat', class: 'primary white--text py-0' },
        { text: 'Non Equipment', values: 'noneq_nm', class: 'primary white--text py-0' },
        { text: 'Frequency', values: 'freq', class: 'primary white--text py-0' },
        { text: 'Location', values: 'asset_location', class: 'primary white--text py-0' },
        { text: 'PPM Activity Status', values: 'asset_status', class: 'primary white--text py-0' }
      ],
      lPpmHeader: [],
      // photos
      lDailyUpdateAttach: {
        files: []
      },
      from_dt: null,
      to_dt: null,
      rep_to_date: null,
      repo_to_date: null,
      repHeadSm: [
        { text: 'Role [Headcount]', value: 'staff_role', class: 'font primary white--text pl-2 pr-0', sortable: false },
        { text: 'Present', value: 'tot_present', class: 'font primary white--text pl-2 pr-0', sortable: false },
        { text: 'Weekoff', value: 'tot_wo', class: 'font primary white--text pl-2 pr-0', sortable: false },
        { text: 'Holiday', value: 'tot_holiday', class: 'font primary white--text pl-2 pr-0', sortable: false },
        { text: 'Standby/OT', value: 'tot_ot', class: 'font primary white--text pl-2 pr-0', sortable: false },
        { text: 'Leave', value: 'tot_leave', class: 'font primary white--text pl-2 pr-0', sortable: false },
        { text: 'Absent', value: 'tot_absent', class: 'font primary white--text pl-2 pr-0', sortable: false },
        { text: 'Pending', value: 'tot_pend', class: 'font primary white--text pl-2 pr-0', sortable: false }
      ],
      repHead: [
        { text: 'Role', value: 'staff_role' },
        { text: 'Present', value: 'tot_present', class: 'pa-0' },
        { text: 'Pending', value: 'tot_pend', class: 'red--text pa-0' }
      ],
      attReport: []
    }
  },
  mounted () {
    this.loadReportDate()
    this.lReport.comm_name = config.COMM_NAME
    // this.loadAttReport()
    this.loadRemark()
    // this.loadCompReport()
    this.loadPowerConsPieChart()
    this.loadPowerGensetPieChart()
    // this.loadWaterLevelChart()
    this.loadWaterConsChart()
    this.loadWaterSources()
    this.loadWaterQualChart()
    this.loadMetricCat()
    // this.loadTaskReport()
    this.loadGenset()
    this.loadWasteChart()
    this.loadHygieneCat()
    // this.loadHygiene()
    this.loadIncidentClass()
    this.loadPpmPlanner()
    this.loadFacDailyUpdateAttachment()
    // this.loadIncidentWeekly()
    this.loadSanityChecksWeekly()
    this.showAttendanceSummary()
  },
  methods: {
    msg (m, type = 0) {
      if (type === 0) {
        this.sbarCol = 'error'
      } else if (type === 1) {
        this.sbarCol = 'success'
      } else {
        this.sbarCol = 'info'
      }
      this.sbar = true
      this.sbarMsg = m
    },

    loadReportDate () {
      var curDate = new Date(this.action)
      this.lReport.rep_date = handy.formatDate(this.action)
      this.rep_to_date = new Date(curDate.setDate(curDate.getDate() + 6))
      this.repo_to_date = handy.formatDate(this.rep_to_date)
      this.rep_to_date = handy.formatDBDate(this.rep_to_date)
    },
    // loadAttReport () {
    //   var qry = {
    //     params: {
    //       from_dt: handy.formatDBDate(this.action),
    //       to_dt: handy.formatDBDate(this.rep_to_date),
    //       comm_id: config.COMM_ID,
    //       is_billable: 1
    //     }
    //   }
    //   this.lReport.attAve = 0
    //   var attVal = {
    //     tot_staff: 0,
    //     tot_present: 0,
    //     tot_hd: 0,
    //     tot_ot: 0,
    //     tot_wo: 0,
    //     tot_holiday: 0,
    //     tot_standBy: 0
    //   }
    //   this.lReport.roleCat = {}
    //   this.lReport.attHeader = []
    //   this.lReport.tot_staff = 0
    //   this.lReport.tot_present = 0
    //   this.lReport.tot_ot = 0
    //   this.axios.get(config.API_URL + '/getAttendanceWeeklyRep/', qry)
    //   .then(response => {
    //     // total attendance in percentage
    //     this.lReport.roleCat = handy.unique(response.data.map(rec => rec.role_cat))
    //     response.data.forEach(rec => {
    //       attVal.tot_staff += rec.role_count + Number(rec.role_count * 6)
    //       attVal.tot_present += rec.tot_present + Number(rec.tot_hd / 2)
    //       attVal.tot_ot += rec.tot_ot
    //       attVal.tot_wo += rec.tot_wo
    //       attVal.tot_holiday += rec.tot_holiday
    //       attVal.tot_standBy += rec.tot_standBy
    //     })
    //     this.lReport.tot_staff = attVal.tot_staff
    //     this.lReport.tot_present = attVal.tot_present
    //     this.lReport.tot_ot = attVal.tot_ot
    //     this.lReport.roleCat.forEach(rec => {
    //       this.attList.push({
    //         role_cat: rec,
    //         attendance: []
    //       })
    //       this.lReport.attHeader.push({
    //         role_cat: rec,
    //         attHead: []
    //       })
    //     })
    //     for (var i = 0; i < response.data.length; i++) {
    //       for (var j = 0; j < this.attList.length; j++) {
    //         if (response.data[i].role_cat === this.attList[j].role_cat) {
    //           this.attList[j].attendance.push({
    //             tot_present: response.data[i].tot_present + Number(response.data[i].tot_hd / 2) + (response.data[i].tot_ot ? ' + ' + Number(response.data[i].tot_ot + (response.data[i].tot_standBy || 0)) : response.data[i].tot_standBy ? ' + ' + response.data[i].tot_standBy : 0) + ' / ' + Number(response.data[i].role_count),
    //             tot_wo: response.data[i].tot_wo,
    //             tot_holiday: response.data[i].tot_holiday,
    //             tot_leave: response.data[i].tot_leave,
    //             tot_hd: response.data[i].tot_hd,
    //             tot_absent: response.data[i].tot_absent
    //           })
    //         }
    //       }
    //       for (var k = 0; k < this.lReport.attHeader.length; k++) {
    //         if (response.data[i].role_cat === this.lReport.attHeader[k].role_cat) {
    //           this.lReport.attHeader[k].attHead.push({
    //             short_form: response.data[i].short_form
    //           })
    //         }
    //       }
    //     }
    //     this.lReport.attAve = Math.round((attVal.tot_present + attVal.tot_ot + attVal.tot_standBy + attVal.tot_wo + attVal.tot_holiday) / attVal.tot_staff * 100)
    //     this.$forceUpdate()
    //   })
    //   .catch(err => {
    //     this.msg(err, true)
    //   })
    // },
    loadRemark () {
      var qry = {
        params: {
          from_dt: handy.formatDBDate(this.action),
          to_dt: handy.formatDBDate(this.rep_to_date),
          comm_id: config.COMM_ID
        }
      }
      this.axios.get(config.API_URL + '/getWeeklyRemarksBasedOnCommId/', qry)
      .then(response => {
        if (response.data.length > 0) {
          this.lReport.remark_attendance = response.data[0].remark_attendance
          this.lReport.remark_water = response.data[0].remark_water
          this.lReport.remark_power = response.data[0].remark_power
          this.lReport.remark_sanity_checks = response.data[0].remark_sanity_checks
          this.lReport.remark_custom_metrics = response.data[0].remark_custom_metrics
          this.lReport.major_observ = response.data[0].major_observ
        }
      })
      .catch(err => {
        this.msg(err, true)
      })
    },
    // loadCompReport () {
    //   var qry = {
    //     params: {
    //       from_dt: handy.formatDBDate(this.action),
    //       comm_id: config.COMM_ID
    //     }
    //   }
    //   this.axios.get(config.API_URL + '/getComplaintWeeklyRep/', qry)
    //   .then(response => {
    //     this.compList = response.data
    //   })
    //   .catch(err => {
    //     this.msg(err, true)
    //   })
    // },
    loadPowerConsPieChart () {
      var qry = {
        params: {
          comm_id: config.COMM_ID,
          from_dt: handy.formatDBDate(this.action),
          to_dt: handy.formatDBDate(this.rep_to_date)
        }
      }
      this.axios.get(config.API_URL + '/getPowerMeterWeeklyRep/', qry)
      .then(response => {
        var resObj = response.data
        var areaLbl = []
        var unitConsVal = []
        this.lReport.eb_unit = 0
        // pie chart
        for (var i = 0; i < resObj.length; i++) {
          areaLbl[i] = resObj[i].area_covered
          unitConsVal[i] = 0
          if (!resObj[i].unit_cons) {
            resObj[i].unit_cons = 0
          }
          unitConsVal[i] += Number(resObj[i].unit_cons.toFixed(2))
          this.lReport.eb_unit += Number(resObj[i].unit_cons.toFixed(2))
        }
        var totZero = 0
        for (i = 0; i < unitConsVal.length; i++) {
          if (unitConsVal[i] === 0) {
            totZero++
          }
        }
        if (totZero === unitConsVal.length) {
          this.nodata = true
        } else {
          this.nodata = false
        }
        // chart 1
        // clear the content if any
        if (this.nodata) {
          setTimeout(() => {
            document.getElementById('div_powercons').innerHTML = 'No data available, check location and area covered configuration'
          }, 500)
          this.$forceUpdate()
        } else {
          setTimeout(() => {
            document.getElementById('div_powercons').innerHTML = '<canvas id="chart_powercons"></canvas>'
            var canvas = document.getElementById('chart_powercons')
            var ctx = canvas.getContext('2d')
            ctx.canvas.height = areaLbl.length * 2.5
            ctx.canvas.width = areaLbl.length * 7
            this.tmpChart = new Chart(ctx, {
              type: 'pie',
              data: {
                labels: areaLbl,
                datasets: [{
                  backgroundColor: ['#e36c09', '#31859b', '#5f497a', '#76923c', '#953734', '#366092', '#17365d', '#494429', '#5f4170', '#4c646e'],
                  data: unitConsVal
                }]
              },
              options: {
                plugins: {
                  datalabels: {
                    formatter: function (value) {
                      return value
                    },
                    color: '#ffffff'
                  }
                },
                title: {
                  display: true,
                  text: 'Electricity Board (Units)'
                },
                legend: {
                  position: 'right'
                }
              }
            })
          }, 500)
          this.$forceUpdate()
        }
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    loadPowerGensetPieChart () {
      var qry = {
        params: {
          comm_id: config.COMM_ID,
          from_dt: handy.formatDBDate(this.action),
          to_dt: handy.formatDBDate(this.rep_to_date)
        }
      }
      this.axios.get(config.API_URL + '/getWeeklyPowerGensetPieChartByCommId/', qry)
      .then(response => {
        var resObj = response.data
        var gensetLbl = []
        var unitConsVal = []
        this.lReport.dg_unit = 0
        // pie chart
        for (var i = 0; i < resObj.length; i++) {
          gensetLbl[i] = resObj[i].genset_nm
          var unitVal = resObj[i].value
          unitConsVal[i] = 0
          for (var d = 0; d < unitVal.length; d++) {
            if (!unitVal[d].units_cons) {
              unitVal[d].units_cons = 0
            }
            unitConsVal[i] += Number(unitVal[d].units_cons)
            this.lReport.dg_unit += unitConsVal[i]
          }
        }
        // chart 1
        // clear the content if any
        if (response.data.length === 0) {
          setTimeout(() => {
            document.getElementById('div_powergenset').innerHTML = 'No data available for DG'
          }, 500)
          this.$forceUpdate()
        } else if (this.lReport.dg_unit === 0) {
          setTimeout(() => {
            document.getElementById('div_powergenset').innerHTML = 'DGs were not run today'
          }, 500)
          this.$forceUpdate()
        } else {
          setTimeout(() => {
            document.getElementById('div_powergenset').innerHTML = '<canvas id="chart_powergenset"></canvas>'
            var canvas = document.getElementById('chart_powergenset')
            var ctx = canvas.getContext('2d')
            ctx.canvas.height = gensetLbl.length * 1.7
            ctx.canvas.width = gensetLbl.length * 4.5
            this.tmpChart = new Chart(ctx, {
              type: 'pie',
              data: {
                labels: gensetLbl,
                datasets: [{
                  backgroundColor: ['#e36c09', '#31859b', '#5f497a', '#76923c', '#953734', '#366092', '#17365d', '#494429'],
                  data: unitConsVal
                }]
              },
              options: {
                plugins: {
                  datalabels: {
                    formatter: function (value) {
                      return value
                    },
                    color: '#ffffff'
                  }
                },
                title: {
                  display: true,
                  text: 'Genset (Units)'
                },
                legend: {
                  position: 'right'
                }
              }
            })
          }, 500)
          this.$forceUpdate()
        }
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    // loadWaterLevelChart () {
    //   var qry = {
    //     params: {
    //       comm_id: config.COMM_ID,
    //       from_dt: handy.formatDBDate(this.action) + ' 00:00:00',
    //       to_dt: handy.formatDBDate(this.rep_to_date) + ' 23:59:59'
    //     }
    //   }
    //   this.axios.get(config.API_URL + '/getWeeklyWaterLevelChartDetailsByCommId/', qry)
    //   .then(response => {
    //     // retrive data from db and construct chart
    //     var resObj = response.data
    //     var watTypeLbl = []
    //     var levelVal = {}
    //     var gw = 0
    //     var dtLbl = [] // for trend chart
    //     var waterLvlKl = {}
    //     var gd = 0
    //     var idx = 0
    //     for (var i = 0; i < resObj.length; i++) {
    //       watTypeLbl[gw] = resObj[i].storage_nm
    //       levelVal[gw] = []
    //       idx = gw++
    //       var lvl = resObj[i].levels
    //       for (var d = 0; d < lvl.length; d++) {
    //         if (lvl[d].water_level === '') {
    //           lvl[d].water_level = 0
    //         }
    //         var didx = dtLbl.indexOf(handy.formatDate(lvl[d].c_date))
    //         if (didx < 0 && lvl[d].c_date) {
    //           dtLbl[gd] = handy.formatDate(lvl[d].c_date)
    //           didx = gd++
    //         }
    //         if (dtLbl[didx] === handy.formatDate(this.action)) {
    //           if (lvl[d].water_level) {
    //             levelVal[idx][i] = lvl[d].water_level // show specific data for the day in first graph in case of single date
    //           }
    //           if (lvl[d].water_level_kl) {
    //             waterLvlKl[i] = lvl[d].water_level_kl + ' KL'
    //           }
    //         }
    //       }
    //     }
    //     // chart 1
    //     // data set
    //     var value = []
    //     for (i = 0; i < watTypeLbl.length; i++) {
    //       value.push(levelVal[i][i])
    //     }
    //     var totZero = 0
    //     for (i = 0; i < value.length; i++) {
    //       if (value[i] === 0) {
    //         totZero++
    //       }
    //     }
    //     if (totZero === value.length) {
    //       this.nodata = true
    //     } else {
    //       this.nodata = false
    //     }
    //     if (this.nodata) {
    //       setTimeout(() => {
    //         document.getElementById('div_waterlevel').innerHTML = 'No data available'
    //       }, 500)
    //       this.$forceUpdate()
    //     } else {
    //       // clear the content if any
    //       document.getElementById('div_waterlevel').innerHTML = '<canvas id="chart_waterlevel"></canvas>'
    //       var canvas = document.getElementById('chart_waterlevel')
    //       canvas.height = watTypeLbl.length > 4 ? watTypeLbl.length * 18 : watTypeLbl.length * 42
    //       var ctx = canvas.getContext('2d')
    //       this.tmpChart = new Chart(ctx, {
    //         type: 'horizontalBar',
    //         data: {
    //           labels: watTypeLbl,
    //           datasets: [{
    //             backgroundColor: 'rgba(' + COLORS[1] + ',0.7)',
    //             data: value,
    //             fill: true
    //           }]
    //         },
    //         options: {
    //           tooltips: {enabled: false},
    //           responsive: true,
    //           maintainAspectRatio: false,
    //           legend: {
    //             display: false,
    //             position: 'bottom',
    //             labels: {
    //               usePointStyle: true,
    //               fontSize: 11
    //             }
    //           },
    //           scales: {
    //             xAxes: [{
    //               ticks: {
    //                 beginAtZero: true,
    //                 min: 0
    //               }
    //             }]
    //           },
    //           hover: {
    //             animationDuration: 0
    //           },
    //           plugins: {
    //             datalabels: {
    //               formatter: function (value) {
    //                 return value > 0 ? value + ' %' : ''
    //               },
    //               color: '#ffffff'
    //             }
    //           }
    //         }
    //       })
    //       this.$forceUpdate()
    //     }
    //   })
    //   .catch(err => {
    //     this.msg(err, 0)
    //   })
    // },
    loadWaterConsChart () {
      var qry = {
        params: {
          comm_id: config.COMM_ID,
          from_dt: handy.formatDBDate(this.action) + ' 00:00:00',
          to_dt: handy.formatDBDate(this.rep_to_date) + ' 23:59:59',
          comingFrom: 'Report',
          vendor_id: config.FM_VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getWeeklyWaterConsChartDetailsByCommId/', qry)
      .then(response => {
        // retrive data from db and construct chart
        var resObj = response.data
        var watTypeLbl = []
        var recVal = {}
        var dtLbl = [] // for trend chart
        var didx = 0
        var widx = 0
        var modeLbl = ['Consumed (KL)']
        recVal[0] = []
        this.lReport.tot_water_cons = 0
        for (var r = 0; r < resObj.length; r++) {
          var cons = resObj[r].cons
          for (var d = 0; d < cons.length; d++) {
            didx = dtLbl.indexOf(handy.formatDBDate(cons[d].c_date))
            if (didx < 0 && cons[d].c_date) {
              didx = dtLbl.length
              dtLbl[didx] = handy.formatDBDate(cons[d].c_date)
            }
            widx = watTypeLbl.indexOf(resObj[r].storage_nm.substring(0, 10))
            if (widx < 0) {
              widx = watTypeLbl.length
              watTypeLbl[widx] = resObj[r].storage_nm.substring(0, 10)
            }
            if (!recVal[0][widx]) {
              recVal[0][widx] = 0
            }
            recVal[0][widx] += Number(cons[d].water_cons)
          }
        }
        // to do: when automated for mulitple timestamps on the same day
        // chart 1 (water receipt and cons)
        // data set
        var dsets = []
        for (var i = 0; i < modeLbl.length; i++) {
          for (var j = 0; j < recVal[i].length; j++) {
            recVal[i][j] = recVal[i][j] > 0 ? recVal[i][j].toFixed(0) : ''
            this.lReport.tot_water_cons += Number(recVal[i][j])
          }
          dsets[i] = {
            label: modeLbl[i],
            backgroundColor: 'rgba(' + COLORS[i] + ',0.7)',
            borderColor: 'rgba(' + COLORS[i] + ',1)',
            data: recVal[i],
            fill: true
          }
        }
        if (this.lReport.tot_water_cons) {
          this.nodata = false
        } else {
          this.nodata = true
        }
        if (this.nodata) {
          document.getElementById('div_watercons').innerHTML = 'No data available, check water consumption configuration'
        } else {
          // clear the content if any
          document.getElementById('div_watercons').innerHTML = '<canvas id="chart_watercons"></canvas>'
          var canvas = document.getElementById('chart_watercons')
          var ctx = canvas.getContext('2d')
          this.tmpChart = new Chart(ctx, {
            type: 'horizontalBar',
            data: {
              labels: watTypeLbl,
              datasets: dsets
            },
            options: {
              plugins: {
                datalabels: {
                  formatter: function (value) {
                    return value || ''
                  },
                  color: '#fff'
                }
              },
              responsive: true,
              maintainAspectRatio: false,
              legend: {
                display: false,
                position: 'bottom',
                labels: {
                  usePointStyle: true,
                  fontSize: 11
                }
              },
              scales: {
                xAxes: [{
                  ticks: {
                    beginAtZero: true
                  }
                }]
              }
            }
          })
        }
        this.$forceUpdate()
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    loadWaterSources () {
      var qry = {
        params: {
          comm_id: config.COMM_ID,
          c_date: handy.formatDBDate(this.action),
          from_dt: handy.formatDBDate(this.action),
          to_dt: handy.formatDBDate(this.rep_to_date)
        }
      }
      this.axios.get(config.API_URL + '/getWeeklyWaterSourcesByCommIdAndcDate/', qry)
      .then(response => {
        if (response.data.length > 0) {
          this.domWatList = response.data
        }
        this.$forceUpdate()
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    loadWaterQualChart () {
      var qry = {
        params: {
          comm_id: config.COMM_ID,
          from_dt: handy.formatDBDate(this.action),
          to_dt: handy.formatDBDate(this.rep_to_date)
        }
      }
      this.axios.get(config.API_URL + '/getWeeklyWaterQualityByCommId/', qry)
      .then(response => {
        // retrive data from db and construct chart
        var resObj = response.data
        var paramLbl = []
        var paramId = []
        var paramUoM = []
        var watTypeLbl = []
        var qualVal = {}
        var stdValMin = []
        var stdValMax = []
        var widx = 0
        var pidx = 0
        var dtIdx = 1
        for (var r = 0; r < resObj.length; r++) {
          pidx = paramId.indexOf(resObj[r].param_id)
          if (pidx < 0) {
            pidx = paramId.length
            paramId[pidx] = resObj[r].param_id
            paramLbl[pidx] = resObj[r].param_name
            qualVal[pidx] = []
          }
          widx = watTypeLbl.indexOf(resObj[r].water_type)
          if (widx < 0) {
            widx = watTypeLbl.length
            watTypeLbl[widx] = resObj[r].water_type
          }
          if (!qualVal[pidx][widx]) {
            qualVal[pidx][widx] = 0
          }
          qualVal[pidx][widx] = Number(resObj[r].val)
          paramUoM[pidx] = resObj[r].uom
          stdValMin[pidx] = Number(resObj[r].std_val_min)
          stdValMax[pidx] = Number(resObj[r].std_val_max)
        }
        // chart 1
        this.paramHead = [
          { text: 'Water Type', value: 'water_qual', class: 'primary white--text text-xs-center py-0', sortable: false }
        ]
        var minMax = ''
        for (var i = 0; i < paramLbl.length; i++) {
          if (stdValMin[i] && stdValMax[i]) {
            minMax = stdValMin[i] + ' to ' + stdValMax[i]
          } else if (stdValMin[i]) {
            minMax = 'min ' + stdValMin[i]
          } else {
            minMax = 'max ' + stdValMax[i]
          }
          // construct table headers dynamically
          this.paramHead.splice(dtIdx++, 0,
            {
              text: paramLbl[i] + '(' + paramUoM[i] + ') [' + minMax + ']', value: paramLbl[i], width: '160px', class: 'font pl-2 pr-0 py-0 text-xs-center white--text primary', sortable: false
            }
          )
        }
        this.paramList = []
        for (i = 0; i < watTypeLbl.length; i++) {
          if (stdValMin[i] && stdValMax[i]) {
            minMax = stdValMin[i] + ' to ' + stdValMax[i]
          } else if (stdValMin[i]) {
            minMax = 'min ' + stdValMin[i]
          } else {
            minMax = 'max ' + stdValMax[i]
          }
          this.paramList.push({
            water_qual: watTypeLbl[i] === 'SWIMMING POOL' ? 'S. POOL' : watTypeLbl[i],
            waterQualTypeValue: []
          })
        }
        // find ave
        for (i = 0; i < paramLbl.length; i++) {
          for (var j = 0; j < watTypeLbl.length; j++) {
            if (qualVal[i][j] && qualVal[i][j] !== '  ') {
              qualVal[i][j] = (Number.isInteger(qualVal[i][j]) || qualVal[i][j] > 50) ? qualVal[i][j].toFixed(0) : qualVal[i][j].toFixed(1)
            }
          }
        }

        // construct value table for each parameter
        for (j = 0; j < watTypeLbl.length; j++) {
          for (i = 0; i < paramLbl.length; i++) {
            this.paramList[j].waterQualTypeValue.push({
              val: qualVal[i][j] || '',
              stdValMin: stdValMin[i],
              stdValMax: stdValMax[i]
            })
          }
        }
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    loadMetricCat () {
      var qry = {
        params: {
          comm_id: config.COMM_ID
        }
      }
      this.axios.get(config.API_URL + '/getWeeklyMetricCatByCommId/', qry)
      .then(response => {
        this.lMet = response.data.filter(rec => rec.metric_cat !== '')
        this.loadMetric(handy.formatDBDate(this.action))
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    loadMetric (curDate) {
      var metCat = this.lMet.filter(rec => rec.metric_cat !== '')
      var qry = {
        params: {
          comm_id: config.COMM_ID,
          from_dt: handy.formatDBDate(this.action),
          to_dt: handy.formatDBDate(this.rep_to_date),
          metric_cat: metCat.map(rec => rec.metric_cat)
        }
      }
      this.axios.get(config.API_URL + '/getWeeklyMetricByCommId/', qry)
      .then(response => {
        this.metricList = response.data
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    loadTaskReport () {
      var qry = {
        params: {
          comm_id: config.COMM_ID,
          from_dt: handy.formatDBDate(this.action),
          to_dt: handy.formatDBDate(this.repo_to_date)
        }
      }
      this.axios.get(config.API_URL + '/getWeeklyTaskReport/', qry)
      .then(response => {
        var resObj = response.data
        var statusLbl = []
        var totTaskVal = []
        // pie chart
        for (var i = 0; i < resObj.length; i++) {
          statusLbl[i] = resObj[i].task_status
          if (!resObj[i].tot_task_status) {
            totTaskVal[i] = 0
          } else {
            totTaskVal[i] = resObj[i].tot_task_status
          }
        }
        var totZero = 0
        for (i = 0; i < totTaskVal.length; i++) {
          if (totTaskVal[i] === 0) {
            totZero++
          }
        }
        if (totZero === totTaskVal.length) {
          this.nodata = true
        } else {
          this.nodata = false
        }
        // chart 1
        // clear the content if any
        if (this.nodata) {
          setTimeout(() => {
            document.getElementById('div_task').innerHTML = 'No data available'
          }, 500)
          this.$forceUpdate()
        } else {
          setTimeout(() => {
            document.getElementById('div_task').innerHTML = '<canvas id="chart_task"></canvas>'
            var canvas = document.getElementById('chart_task')
            canvas.height = statusLbl.length * 23
            canvas.width = statusLbl.length * 35
            var ctx = canvas.getContext('2d')
            this.tmpChart = new Chart(ctx, {
              type: 'pie',
              data: {
                labels: statusLbl,
                datasets: [{
                  backgroundColor: ['#e36c09', '#31859b', '#5f497a', '#76923c', '#953734', '#366092', '#17365d', '#494429'],
                  data: totTaskVal
                }]
              },
              options: {
                plugins: {
                  datalabels: {
                    formatter: function (value) {
                      return value || ''
                    },
                    color: '#ffffff'
                  }
                },
                title: {
                  display: false
                },
                legend: {
                  position: 'bottom'
                }
              }
            })
          }, 500)
          this.$forceUpdate()
        }
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    loadGenset () {
      var qry = {
        params: {
          comm_id: config.COMM_ID,
          from_dt: handy.formatDBDate(this.action),
          to_dt: handy.formatDBDate(this.rep_to_date)
        }
      }
      this.axios.get(config.API_URL + '/getWeeklyGensetByGensetId/', qry)
      .then(response => {
        this.gensetList = response.data
        this.lgen.totPurchasedStock = 0
        this.lgen.totStock = 0
        this.lgen.units_cons = 0
        this.lgen.run_hrs = 0
        this.lgen.kwh_kva = 0
        this.lgen.level = 0
        this.gensetList.forEach(rec => {
          this.lgen.totPurchasedStock += Number(rec.purchased)
          this.lgen.totStock += Number(rec.stock)
          this.lgen.units_cons += Number(rec.units_cons)
          this.lgen.run_hrs += Number(rec.run_hrs)
          this.lgen.level += Number(rec.level)
        })
        this.dieselList.push({
          diesel_nm: 'Diesel Purchased',
          val: this.lgen.totPurchasedStock || ''
        })
        this.dieselList.push({
          diesel_nm: 'Diesel Barrel Stock',
          val: this.lgen.totStock || ''
        })
        this.dieselList.push({
          diesel_nm: 'Units(KWH)',
          val: this.lgen.units_cons || ''
        })
        this.dieselList.push({
          diesel_nm: 'Running Hours',
          val: this.lgen.run_hrs || ''
        })
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    loadHygieneCat () {
      var qry = {
        params: {
          comm_id: config.COMM_ID
        }
      }
      this.axios.get(config.API_URL + '/getWeeklySanCheckCatByCommId/', qry)
      .then(response => {
        this.hygCats = response.data
        this.loadHygiene()
      })
      .catch(err => {
        this.msg(err, true)
      })
    },
    loadHygiene () {
      var qry = {
        params: {
          comm_id: config.COMM_ID,
          from_dt: handy.formatDBDate(this.action),
          to_dt: handy.formatDBDate(this.rep_to_date)
        }
      }
      this.hygList = []
      this.axios.get(config.API_URL + '/getSanCheckByCommIdAndcDate/', qry)
      .then(response => {
        this.hygList = response.data
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    loadIncidentClass () {
      this.axios.get(config.API_URL + '/getIncidentClass/')
      .then(response => {
        this.incidentTypes = handy.unique(response.data.map(rec => rec.incident_type)).sort()
        this.loadIncidents()
      })
      .catch(err => {
        this.msg(err, true)
      })
    },
    loadIncidents () {
      var qry = {
        params: {
          comm_id: config.COMM_ID,
          from_dt: handy.formatDBDate(this.action) + ' 00:00:00',
          to_dt: handy.formatDBDate(this.rep_to_date) + ' 23:59:59'
        }
      }
      this.incidentList = []
      this.axios.get(config.API_URL + '/getIncidentListWeeklyRep/', qry)
      .then(response => {
        if (response.data.length > 0) {
          this.incidentList = response.data
        } else {
          this.incidentTypes.forEach(rec => {
            this.incidentList.push({
              incident_type: rec,
              incident_class: 'NIL'
            })
          })
        }
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    loadPpmPlanner () {
      var qry = {
        params: {
          comm_id: config.COMM_ID,
          from_dt: handy.formatDBDate(this.action),
          to_dt: handy.formatDBDate(this.rep_to_date)
        }
      }
      this.lPpmHeader = []
      this.axios.get(config.API_URL + '/getPpmPlannerListDailyRep/', qry)
      .then(response => {
        this.lPpmHeader = response.data
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    loadFacDailyUpdateAttachment () {
      var qry = {
        params: {
          comm_id: config.COMM_ID,
          from_dt: handy.formatDBDate(this.action),
          to_dt: handy.formatDBDate(this.rep_to_date)
        }
      }
      this.lDailyUpdateAttach.files = []
      this.axios.get(config.API_URL + '/getAttachmentByCDateWeekly/', qry)
      .then(response => {
        this.lDailyUpdateAttach.files = response.data
        this.$forceUpdate()
      })
      .catch(err => {
        this.msg(err.response.data, 0)
        this.lDailyUpdateAttach.files = []
      })
    },
    downoadAsPdf () {
      // pdf options
      let opt = {
        margin: 14,
        filename: this.lReport.comm_name + '_Report_' + handy.formatDate(this.action) + '_to_' + handy.formatDBDate(this.rep_to_date) + '.pdf',
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { orientation: 'landscape' },
        pagebreak: { before: '#pageBreak' }
      }

      var canvas = document.getElementById('pdf_report')
      html2pdf(canvas, opt)
    },
    loadWasteChart () {
      var qry = {
        params: {
          comm_id: config.COMM_ID,
          from_dt: handy.formatDBDate(this.action),
          to_dt: handy.formatDBDate(this.rep_to_date)
        }
      }
      this.axios.get(config.API_URL + '/getWasteByCommIdAndcDate/', qry)
      .then(response => {
        this.lWaste = response.data.filter(rec => handy.formatDBDate(rec.c_date) === handy.formatDBDate(this.fromDate))
        var resObj = response.data
        var wasteTypeLbl = []
        var recVal = {}
        var dtLbl = [] // for trend chart
        var recAvgVal = {}
        var didx = 0
        var widx = 0

        recVal[0] = []
        for (var r = 0; r < resObj.length; r++) {
          didx = dtLbl.indexOf(handy.formatDBDate(resObj[r].c_date))

          if (didx < 0 && resObj[r].c_date) {
            didx = dtLbl.length
            dtLbl[didx] = handy.formatDBDate(resObj[r].c_date)
          }

          widx = wasteTypeLbl.indexOf(resObj[r].waste_type)
          if (widx < 0) {
            widx = wasteTypeLbl.length
            wasteTypeLbl[widx] = resObj[r].waste_type
            recVal[widx] = []
            recAvgVal[widx] = []
          }
          if (this.aDay) {
            // show specefic data for the day in first graph in case of single date
            if (dtLbl[didx] === handy.formatDBDate(this.fromDate)) {
              recVal[widx][0] = resObj[r].kgs
            }
          } else {
            if (recVal[widx][0] === undefined) {
              recVal[widx][0] = 0
            }
            recVal[widx][0] += Number(resObj[r].kgs)
          }
          // for trend
          if (recAvgVal[widx][didx] === undefined) {
            recAvgVal[widx][didx] = 0
          }
          recAvgVal[widx][didx] += resObj[r].kgs
        } // for every rec
        // chart 1
        // data set
        var dsets = []
        var lColor = ['0,255,0', '0,0,255', '255,0,0']
        for (var i = 0; i < wasteTypeLbl.length; i++) {
          dsets[i] = {
            label: wasteTypeLbl[i] + ' (kg)',
            backgroundColor: 'rgba(' + lColor[i] + ',0.4)',
            borderColor: 'rgba(' + lColor[i] + ',1)',
            data: recVal[i],
            fill: true
          }
        }
        // clear the content if any
        document.getElementById('div_waste').innerHTML = '<canvas id="chart_waste"></canvas>'
        var canvas = document.getElementById('chart_waste')
        var ctx = canvas.getContext('2d')
        this.tmpChart = new Chart(ctx, {
          type: 'horizontalBar',
          data: {
            labels: ['Wastage (kg)'],
            datasets: dsets
          },
          options: {
            plugins: {
              datalabels: {
                formatter: function (value) {
                  return value + ' kg'
                },
                color: '#ffffff'
              }
            },
            responsive: true,
            maintainAspectRatio: false,
            legend: {
              display: true,
              position: 'bottom',
              labels: {
                usePointStyle: true,
                fontSize: 11
              }
            },
            scales: {
              xAxes: [{
                ticks: {
                  beginAtZero: true,
                  min: 0
                }
              }]
            },
            hover: {
              animationDuration: 0
            }
          }
        })
      })
    },
    loadSanityChecksWeekly () {
      var qry = {
        params: {
          comm_id: config.COMM_ID,
          from_dt: handy.formatDBDate(this.action),
          to_dt: handy.formatDBDate(this.rep_to_date)
        }
      }
      this.sanList = []
      this.lSan = {}
      this.axios.get(config.API_URL + '/getSanCheckByCommIdAndcDate/', qry)
      .then(response => {
        this.sanList = response.data
        this.lSan = handy.unique(this.sanList.map(rec => handy.formatDate(rec.c_date)))
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    loadIncidentWeekly () {
      var qry = {
        params: {
          comm_id: config.COMM_ID,
          from_dt: this.from_dt,
          to_dt: this.to_dt
        }
      }
      this.lIncident = []
      this.lInc = {}
      this.axios.get(config.API_URL + '/getIncidentListDailyRep/', qry)
      .then(response => {
        this.lIncident = response.data
        this.lInc = handy.unique(this.lIncident.map(rec => handy.formatDate(rec.created_on)))
        this.showIncident = true
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    showAttendanceSummary () {
      var qry = {
        params: {
          comm_id: config.COMM_ID,
          from_dt: handy.formatDBDate(this.action),
          to_dt: handy.formatDBDate(this.rep_to_date),
          group_by: 'role',
          is_billable: 1
        }
      }
      this.attReport = []
      this.axios.get(config.API_URL + '/getAttendanceRep/', qry)
      .then(response => {
        this.attReport = response.data
        // calculate few fields
        this.attReport.forEach(rec => {
          rec.staff_role = rec.staff_role + ' [' + rec.role_count + ']'
          rec.tot_present = rec.tot_present + (rec.tot_hd / 2)
          rec.tot_absent = rec.tot_absent + (rec.tot_hd / 2)
        })
        // this.showSummary = true
      })
      .catch(err => {
        this.msg(err.response.data, 0)
      })
    }
  }
}
</script>

<style>
.v-card__text {
    padding: 1px;
    padding-top: 1px;
    padding-right: 1px;
    padding-bottom: 1px;
    padding-left: 1px;
    width: 100%;
  }

</style>



// WEBPACK FOOTER //
// WeeklyReport.vue?48d4073c